import { Box } from '@material-ui/core';

import { FlexColumn } from '@/components/shared/components/FlexColumn';
import { Font } from '@/components/shared/components/Font';
import { Text } from '@/components/shared/components/Text';

interface HeaderProps {
  title: string;
  description?: string;
}

const Header = ({ title, description }: HeaderProps) => {
  return (
    <Box>
      <Font variant="h4" color="title">
        <Text strong tId={title} />
      </Font>
      {description && (
        <Font variant="body2" color="textPrimary">
          <Text tId={description} />
        </Font>
      )}
    </Box>
  );
};

interface ContentProps {
  children: React.ReactNode;
}

const Content = ({ children }: ContentProps) => {
  return (
    <FlexColumn gridGap={16} width="100%">
      {children}
    </FlexColumn>
  );
};

interface FooterProps {
  children: React.ReactNode;
}

const Footer = ({ children }: FooterProps) => {
  return (
    <Box mt={4} display={'inline-flex'} width={'100%'} justifyContent="flex-end" gridGap={16}>
      {children}
    </Box>
  );
};

export const Section = {
  Header,
  Content,
  Footer,
};
